import { Component, h } from 'preact';
import { AirCalendarPrice, Properties, WidgetTab } from '../../common';
import { EnvConfig, GtmService, Navigator } from '../../config';
import { ModalContext } from '../../modal';
import { actions, Actions, BookingState, connectStore, SelectionState } from '../../store';
import { isNotEmpty } from '../../utils';
import AirCalendarModal from './AirCalendarModal/AirCalendarModal';

interface StoreProps {
  prices?: AirCalendarPrice[];
  envConfig: EnvConfig;
  selection: SelectionState;
  navigator: Navigator;
  gtmService: GtmService;
  previousSearchesEnabled: boolean;
  isAward: boolean;
}

const mapStateToProps = ({
  price: { airCalendar },
  envConfig,
  selection,
  extensionApi: { navigator, gtmService },
  ux: { previousSearchesEnabled },
  currentTab,
}: BookingState): StoreProps => ({
  prices: airCalendar,
  envConfig,
  selection,
  navigator,
  gtmService,
  previousSearchesEnabled,
  isAward: currentTab === WidgetTab.AWARD,
});

type EffectiveProps = Properties & StoreProps & Actions;

@connectStore({ mapStateToProps, actions })
export default class AirCalendar extends Component {
  render({
    prices,
    setTravelDates,
    returnFromAirCalendar,
    envConfig,
    selection,
    navigator,
    gtmService,
    previousSearchesEnabled,
    isAward,
  }: EffectiveProps) {
    if (isNotEmpty(prices)) {
      (this.context as ModalContext).modal.showModal(
        <AirCalendarModal
          class="open"
          prices={prices}
          dateSelected={setTravelDates}
          envConfig={envConfig}
          selection={selection}
          navigator={navigator}
          gtmService={gtmService}
          previousSearchesEnabled={previousSearchesEnabled}
          isAward={isAward}
        />,
        returnFromAirCalendar
      );
    }
    return '';
  }
}
